import * as React from 'react'

import { Media } from '~/components'

import { HeaderDesktop, HeaderDesktopProps } from './header-desktop'
import { HeaderMobile, HeaderMobileProps } from './header-mobile'

export type HeaderProps = HeaderDesktopProps & HeaderMobileProps

export function Header(props: HeaderProps) {
  const { numOfHints, title } = props

  return (
    <Media
      mobile={() => <HeaderMobile title={title} numOfHints={numOfHints} />}
      desktop={() => <HeaderDesktop title={title} numOfHints={numOfHints} />}
    />
  )
}
